import React, { useEffect } from "react";
import { Button, Text } from "@chakra-ui/react";
import { FiDownload } from "react-icons/fi";
import { InfoPage, InfoBody, InfoSectionTitle } from "../infoShared";

export const AccessibilityDeclarationView: React.FC = () => {
  useEffect(() => {
    document.title = "Deklaracja dostępności";
  }, []);

  const pdfUrl = `${process.env.REACT_APP_BACKEND_URL}/api/v1/documents/accessibility`;

  return (
    <InfoPage
      eyebrow="Dostępność"
      title="Deklaracja dostępności"
      subtitle="Chcemy, by z platformy mógł korzystać każdy — niezależnie od sprawności i używanej technologii."
    >
      <InfoBody narrow>
        <InfoSectionTitle>Nasze zobowiązanie</InfoSectionTitle>
        <Text fontSize={{ base: "16px", md: "17px" }} color="gray.700" lineHeight="1.7" mb="16px">
          Zobowiązujemy się zapewnić dostępność platformy lubbezposrednio.pl zgodnie z obowiązującymi przepisami
          oraz wytycznymi WCAG. Pełna treść deklaracji — wraz z informacją o statusie zgodności, danymi kontaktowymi i
          procedurą zgłaszania uwag — znajduje się w dokumencie poniżej.
        </Text>
        <Text fontSize={{ base: "16px", md: "17px" }} color="gray.700" lineHeight="1.7" mb="28px">
          Jeśli napotkasz barierę w dostępności, daj nam znać — postaramy się ją usunąć.
        </Text>

        <Button as="a" href={pdfUrl} target="_blank" bg="primary" color="white" borderRadius="12px" fontWeight="700" px="26px" py="14px" h="auto" leftIcon={<FiDownload />} _hover={{ bg: "#36007a" }}>
          Pobierz pełną deklarację (PDF)
        </Button>
      </InfoBody>
    </InfoPage>
  );
};
